import PropTypes from 'prop-types'
import { getSeasonName } from '../../helper/card'

const SeasonName = ({ season }) => getSeasonName(season)

SeasonName.propTypes = {
	season: PropTypes.object.isRequired
}

export default SeasonName
